<script lang="ts" setup>
withDefaults(defineProps<{ showLogout?: boolean }>(), {
  showLogout: true,
})

const userStore = useUserStore()
const { t } = useTranslation()

const onLogout = () => {
  performLogout()
}
</script>

<template>
  <div
    class="flex flex-col gap-2 sm:!flex-row"
  >
    <IaHeading :level="3">
      {{ t('myAccount.title.customerAccount') }}
    </IaHeading>
    <div class="flex gap-2 lt-sm:justify-between">
      <IaHeading
        :level="3"
        font="700"
      >
        {{ userStore.fullName }}
      </IaHeading>

      <IaLink
        v-if="showLogout"
        underline
        color="!primaryRed-500"
        :responsive-size="{ smDown: 'sm' }"
        class="self-end !m-0"
        as="button"
        @click="onLogout"
      >
        {{ t('myAccount.title.logout') }}
      </IaLink>
    </div>
  </div>
</template>
